import { render, staticRenderFns } from "./userdata.vue?vue&type=template&id=7650003a&scoped=true&"
import script from "./userdata.vue?vue&type=script&lang=js&"
export * from "./userdata.vue?vue&type=script&lang=js&"
import style0 from "./userdata.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./userdata.vue?vue&type=style&index=1&id=7650003a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7650003a",
  null
  
)

export default component.exports